export default __webpack_public_path__ + "static/media/Nunito-Regular.0ca8e286.woff2";